<template>
  <ul class="list-disc list-inside fz-18" style="line-height:1.666">
    <li v-for="(item, index) in items" :key="item">{{item}} <br><br v-if="index !== items.length - 1"></li>
  </ul>
</template>

<script>
export default {
  name: "markedList",
  props: ['items']
}
</script>

<style scoped>

</style>